import { configFetch as fetch } from '@laigu/utils';

// 获取消息流 (order 0 为当前的消息流，1历史的消息流)
export const getConversationStreamApi = ({ trackId, convId, order = 0 }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${trackId}/streams/v2`,
      method: 'get',
      params: {
        conv_id: convId,
        order
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        const { streams } = data;
        let newStreams = [];
        streams.forEach(stream => {
          newStreams = [...newStreams, ...stream];
        });
        resolve({ ...data, streams: newStreams });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 发送消息
export const sendMessageApi = ({ trackId, content, convId, type, extra, operator_msg = [] }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/agent/send_msg`,
      method: 'post',
      data: {
        content,
        type,
        extra,
        track_id: trackId,
        conversation_id: convId,
        operator_msg
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve({ ...data });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 发送内部消息
export const sendInternalMessageApi = ({ trackId, content, convId, type, extra }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/agent/send_internal_msg`,
      method: 'post',
      data: {
        content,
        type,
        extra,
        track_id: trackId,
        conversation_id: convId,
        browser_id: 'agent'
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve({ msg: data, success: true });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 上传图片
export const sendImageApi = ({ file, type, onUploadProgress, isUploadImage }) => {
  const formData = new FormData();
  formData.append('file', file);
  if (type) {
    formData.append('type', type);
  }
  const params = {
    url: `/upload`,
    method: 'file',
    data: formData,
    onUploadProgress,
    isUploadImage: isUploadImage
  };
  return new Promise((resolve, reject) => {
    fetch(params)
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve({ ...data, url: data.photo_key });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 上传文件
export const sendFileApi = ({ file, onUploadProgress, url, fields }) => {
  const formData = new FormData();
  const arr = Object.keys(fields);

  arr.forEach(data => {
    formData.append(data, fields[data]);
  });

  formData.append('file', file);

  return new Promise((resolve, reject) => {
    fetch({
      url,
      baseURL: '',
      method: 'file',
      data: formData,
      type: 'file',
      onUploadProgress,
      deleteEntid: true
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve({ ...data });
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 发送卡片消息
export const sendMessageCardApi = ({ trackId, content, type, extra }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/agent/send_card`,
      method: 'post',
      data: {
        track_id: trackId,
        type,
        content,
        extra
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 对话结束
export const endConversationApi = ({ trackId, convId }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/agent/end_conversation',
      method: 'post',
      data: {
        track_id: trackId,
        conversation_id: convId
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 对话转接
export const redirectConversationApi = ({ convId, to }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/agent/conversation/${convId}/redirect`,
      method: 'post',
      data: {
        to
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 对话转接至客服组
export const redirectConversationByGroupApi = ({ convId, groupToken }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/agent/conversation/${convId}/group_redirect`,
      method: 'post',
      data: {
        group_token: groupToken
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 对话转接至客服组
export const redirectConversationToAI = ({ convId }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/unified-api/conversations/v1/agent/conversation/${convId}/ai_redirect`,
      method: 'post'
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 对话小结
export const handleSummaryConversationApi = ({ convId, content, tagIds }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${convId}/summary`,
      method: 'post',
      data: {
        content,
        tag_ids: tagIds
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 对话提醒
export const handleInternalRemindApi = ({ convId, agentId }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${convId}/internal_remind`,
      method: 'post',
      data: {
        agent_id: agentId
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 获取发送文件配置
export const fetchUploadPoliciesApi = data => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/upload/oss/policies',
      method: 'post',
      data
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 邀请评价
export const inviteEvaluationApi = ({ convId }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/conversation/${convId}/invite_evaluation`,
      method: 'post'
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

// 辅助回答
export const handleSuggestionApi = ({ convId, question, visit_id }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/robot/suggestion',
      method: 'get',
      params: {
        conv_id: convId,
        q: question,
        visit_id
      }
    })
      .then(req => {
        // 处理返回的数据
        const { data } = req;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const withdrawMessageApi = (msgId, is_truested = false) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/agent/withdraw_msg',
      method: 'post',
      data: {
        msg_id: msgId,
        is_truested
      }
    })
      .then(res => {
        const { data } = res;
        resolve(data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const toTranslation = data => {
  return fetch({
    url: '/unified-api/conversations/v1/conversation/translate/v2',
    method: 'post',
    data
  });
};
